import React, { useContext } from "react";
import { ResponsiveContext } from "grommet";

import { PlaidTokensDesktop, PlaidTokensMobile } from "./";

export const AdminPlaidTokens = () => {
  const size = useContext(ResponsiveContext);
  return size === "small" ? <PlaidTokensMobile /> : <PlaidTokensDesktop />;
};
